import React, { Component } from "react";
import { IsEmpty, redirectToUrl } from "../../../util/commonFunctions";
import { Link, withRouter } from "react-router-dom";
import { showLoader, hideLoader } from "../../../actions";
import { connect } from "react-redux";

class Breadcrumb extends Component {
    constructor(props) {
        super(props);
    }
    render = () => {
        return (
            <div className="breadcrumbWrapper">
                {!IsEmpty(this.props.hierarchy) && (
                    this.props.hierarchy.map((nav, index, arr) => {
                        return (
                            <React.Fragment key={`breadcrumb-${index}`}>
                                {index === 0 && //first element
                                    <Link className="customBreadcrumb" to={`/`}>
                                        Home
                                    </Link>
                                }
                                {arr.length - 1 !== index &&
                                    <>
                                        <Link
                                            className="customBreadcrumb"
                                            to={`/topic/${nav.name}/${nav.id}`}
                                            onClick={event =>
                                                redirectToUrl(
                                                    event,
                                                    nav.id,
                                                    this.props,
                                                    this.props.showLoader,
                                                    this.props.hideLoader,
                                                    this.props.currentLanguage
                                                )
                                            }
                                        >
                                            {nav.name}
                                        </Link>
                                    </>
                                }

                                {arr.length - 1 === index && // Last Element
                                    <h1 className="lastCustomBreadcrumb">
                                        {nav.name}
                                    </h1>
                                }
                            </React.Fragment>
                        );
                    })
                )}
            </div>
        );
    };
}

const mapStateToProps = state => {
    return {
      currentLanguage: state.language.currentLanguage
    };
  };

const mapDispatchToProps = dispatch => {
    return {
        showLoader: () => dispatch(showLoader()),
        hideLoader: () => dispatch(hideLoader())
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Breadcrumb));